import { render, staticRenderFns } from "./PageTeamSalesManagement.vue?vue&type=template&id=f5c64390&scoped=true"
import script from "./PageTeamSalesManagement.vue?vue&type=script&lang=js"
export * from "./PageTeamSalesManagement.vue?vue&type=script&lang=js"
import style0 from "./PageTeamSalesManagement.vue?vue&type=style&index=0&id=f5c64390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c64390",
  null
  
)

export default component.exports